export const ROUTES_NAMES = {
    documentation: '/documentacao',
    notifications: '/notificacoes',
    exportReport: '/export-relatorios',
    login: '/login',
    accessSystem: '/accessSystem',
    reports: '/relatorios',
    notifyEvent: '/notificar-evento',
    notifySent: '/notificacao-realizada',
    notifyEventPatient: '/notificar-evento-paciente',
    notifySentPatient: '/notificacao-realizada-paciente',
    configurationsRoutes: {
        configurations: '/configuracoes',
        configurationsUsers: '/configuracoes/usuarios',
        users: 'usuarios',
        newUser: 'novo-usuario',
        accessUser: 'edicao-usuario',
        configurationsSectors: '/configuracoes/setores',
        configurationsUnities: '/configuracoes/unidades',
        editSectors: '/configuracoes/edicao-setor'
    }
}
